import api from '@/lib/api';
import { currentMonth } from './clock';

// Caché en memoria del libro de rentas (por mes) para que "Control de Rentas" abra al instante.
// Finanzas precarga el mes actual al entrar; la página pinta desde caché y revalida en segundo plano.
const cache = new Map();
const inflight = new Map();

export const currentMonthKey = () => currentMonth();

export const getCachedLedger = (month) => cache.get(month) || null;

export const fetchRentLedger = (month) => {
  if (inflight.has(month)) return inflight.get(month);
  const p = api.get('/cobranza/rent-ledger', { params: { month } })
    .then(({ data }) => { cache.set(month, data); return data; })
    .finally(() => inflight.delete(month));
  inflight.set(month, p);
  return p;
};

export const invalidateRentLedger = () => cache.clear();

export const prefetchRentLedger = () => {
  const m = currentMonthKey();
  if (!cache.has(m) && !inflight.has(m)) fetchRentLedger(m).catch(() => {});
  import('../pages/RentMovements').catch(() => {});
};
